module.exports = __webpack_public_path__ + "static/Texas-9ee64485c2762f9ee3e270586028d517.jpg";